import { store } from '@/store/store';
import klcnsEvent from '@/constants/klcnsEvent';
import logReport from '@/util/logReport';
import klcnsAgtStaDefs from '@/util/call/klcns/klcnsAPI/klcnsAgtStaDefs';
import klcnsCommon from '@/util/call/klcns/klcnsAPI/klcnsCommon';
import apiEvent from '@/util/call/apiEvent';
import eventBus from '@/EventBus';
import helpers from '@/util/helpers';

function getTelNumber() {
  return store.getters.telNumber;
}

function sendMessage(msg) {
  let result = true;
  const message = msg.action ? Object.assign(msg, { extension: getTelNumber() }) : msg;

  try {
    store.dispatch('sendMessageToCallSocket', message ? JSON.stringify(message) : null);
  } catch (e) {
    console.error('error while sending: ', e);
    return !result;
  }
  return result;
}

function klcnsStartMonitor() {
  store.commit('setChannelUniqueKey', store.getters.callInfo.channelUniqueKey);
  store.commit('changeIsTelIng', true);
  store.commit('changeIsValidTel', true);
  store.commit('initDimmed');
  store.commit('LOGIN_CALL');
  const values = {
    action: klcnsEvent.PING
  };

  store.commit('changeCallEvent', klcnsEvent.START_MONITOR);
  logReport.write('[START-MONITOR] [CHANGE-CALL-EVENT] startMonitor');

  let intervalObj = setInterval(() => {
    if (!store.getters.IS_TEL_ING) {
      clearInterval(intervalObj);
      return false;
    }

    if (store.getters.pingTryCount < 5) {
      if (store.getters.pingTryCount > 2) {
        logReport.write(`[콜 소켓] - 소켓 응답 지연... ${store.getters.pingTryCount * 2500}ms`);
      }
      store.commit('increasePingTryCnt');
      sendMessage(values);
    } else {
      clearInterval(intervalObj);
      setTimeout(() => {
        eventBus.$emit('call-reconnect-start'); // @@@ 이벤트 버스 언젠간 걷어내야 함
      }, 3000);
    }
  }, 2500);
}

// 상담사 상태 변경하기
function klcnsSetAgentStatus(agtMode, subStatus) {
  if (!agtMode && !subStatus) return false;
  if (agtMode < 0 || agtMode > 18) return false;

  if (agtMode === klcnsAgtStaDefs.AgentMode.AM_LOG_IN && klcnsCommon.IS_CHANGE_STATUS) {
    klcnsCommon.IS_CHANGE_STATUS = false;
  } else if (agtMode === klcnsAgtStaDefs.AgentMode.AM_WORK_NOT_READY) {
    klcnsCommon.IS_CHANGE_STATUS = false;
  }

  if (klcnsCommon.IS_CHANGE_STATUS) {
    setTimeout((agtMode, subStatus) => {
      klcnsSetAgentStatus(agtMode, subStatus);
    }, 500);
    return false;
  }

  let status = 0;
  if (!isNaN(agtMode)) {
    if (subStatus) {
      const mode = `${agtMode}_${subStatus}`;
      status = String(klcnsAgtStaDefs.NumberAgentMode[mode] || mode);
    } else {
      status = String(klcnsAgtStaDefs.AgentMode[agtMode] || agtMode);
    }
  } else {
    status = String(klcnsAgtStaDefs.AgentMode[agtMode]);
  }

  klcnsCommon.IS_CHANGE_STATUS = true;
  if (agtMode < 0 || agtMode > 18) {
    return false;
  }

  const values = {
    action: klcnsEvent.SET_AGENT_STATE,
    option: status
  };

  logReport.write(`[SET_AGENT_STATUS] status: ${status}`);
  return sendMessage(values);
}

function klcnsGetAgentStatus() {
  // option
  //  0: 자신보기
  //  1: 전체보기
  const values = {
    action: klcnsEvent.GET_AGENT_STATE
  };
  return sendMessage(values);
}

// 전화 걸기
function klcnsOriginate(callNumber, serviceNumber) {
  const rid = serviceNumber.split('-').join('');
  store.commit('changeCallEvent', klcnsEvent.ORIGINATE);
  store.commit('changeCallUserKey', callNumber);
  store.commit('changeDnis', rid);
  store.commit('changeCurrentCallBrand', { dnis: rid });
  logReport.write(`[EXTERNAL-CALL] [CHANGE-CALL-EVENT] Originate callNumber: ${callNumber}, serviceNumber: ${serviceNumber}`);
  const values = {
    action: klcnsEvent.ORIGINATE,
    dial_number: callNumber,
    rid_number: rid,
    rid_type: '3'
  };
  return sendMessage(values);
}

// 전화 받기
function klcnsAnswer() {
  const values = {
    action: klcnsEvent.ANSWER
  };
  logReport.write('[ANSWER]');
  return sendMessage(values);
}

// 전화 끊기
function klcnsHangUp() {
  const values = {
    action: klcnsEvent.HANG_UP
  };
  logReport.write('[HANG-UP]');
  return sendMessage(values);
}

// 전화 이관
function klcnsTransfer(callNumber) {
  const values = {
    action: 'Atxfer',
    trans_number: callNumber,
    context: 'transfer-call'
  };
  logReport.write(`[TRANSFER] [CHANGE-CALL-EVENT] trans_number: ${callNumber}`);
  store.commit('changeCallEvent', klcnsEvent.AT_XFER);

  return sendMessage(values);
}

// 이관 취소
function klcnsTransferCancel() {
  const values = {
    action: klcnsEvent.CANCEL_AT_XFER
  };
  logReport.write('[TRANSFER-CANCEL]');
  return sendMessage(values);
}

// 통화 보류
function klcnsHoldAudio(isHold) {
  // isHold:
  // true: 보류 활성
  // false: 보류 비활성
  const values = {
    action: klcnsEvent.HOLD_AUDIO,
    option: isHold ? 'on' : 'off'
  };
  store.commit('changeIsHold', isHold);
  logReport.write(`[HOLD]: ${values.option}`);
  return sendMessage(values);
}

// 음소거 (CG 미사용 기능)
function klcnsMuteAudio(isMute) {
  // isMute
  // true: 음소거 활성
  // false: 음소거 비활성
  const values = {
    action: klcnsEvent.MUTE_AUDIO,
    option: isMute ? 'on' : 'off'
  };
  logReport.write('[MUTE]');
  return sendMessage(values);
}

// UserEvent 조회 (CG 미사용 기능)
function klcnsGetUserEvent() {
  const values = {
    action: klcnsEvent.GET_USER_EVENT
  };
  logReport.write('[GET_USER_EVENT]');
  return sendMessage(values);
}

// 감청하기
function klcnsSpyCall(callnumber, option) {
  store.commit('changeCallEvent', klcnsEvent.SPY_CALL);
  let values = {
    action: 'SpyCall',
    target_number: callnumber,
    option: option
  };

  return sendMessage(values);
}

function EventProc(rcvData) {
  if (!rcvData) return;
  const { event, response, data } = rcvData;
  if (!event) return;

  switch (event) {
    case klcnsEvent.PING_ACTION:
      pingAction(response);
      break;
    case klcnsEvent.GET_AGENT_STATE_ACTION:
      getAgentStateAction();
      break;
    case klcnsEvent.SET_AGENT_STATE_ACTION:
      setAgentStateAction(data);
      break;
    case klcnsEvent.ORIGINATE_ACTION:
      originateAction(response);
      break;
    case klcnsEvent.ANSWER_ACTION:
      answerAction(response);
      break;
    case klcnsEvent.HANG_UP_ACTION:
      hangupAction();
      break;
    case klcnsEvent.ATXFER_ACTION:
      atxferAction();
      break;
    case klcnsEvent.CANCEL_AT_XFER_ACTION:
      cancelAtxferAction();
      break;
    case klcnsEvent.HOLD_AUDIO_ACTION:
      holdAudioAction(response, data);
      break;
    case klcnsEvent.GET_USER_EVENT:
      getUserEvent();
      break;
    case klcnsEvent.RINGING:
      ringing(data);
      break;
    case klcnsEvent.BRIDGE:
      bridge(data);
      break;
    case klcnsEvent.HANG_UP:
      hangUp(data);
      break;
    case klcnsEvent.TRANSFER_ANSWER:
      transferAnswer();
      break;
    case klcnsEvent.SPY_CALL_ACTION:
      spyCallAction(response);
      break;
    case klcnsEvent.SPY_STOP:
      spyStop();
      break;
  }
}

function pingAction(response) {
  if (response === 'Success') {
    store.commit('resetPingTryCnt');
  }
}

function getAgentStateAction() {
  // 추후 필요할 경우 구현
}

function setAgentStateAction(data) {
  try {
    logReport.write(`[SET_AGENT_STATE_ACTION] data: ${JSON.stringify(data)}`);
  } catch (e) {
    logReport.write(`[SET_AGENT_STATE_ACTION] 응답에러: ${data}`);
  }

  const state = data.state.toString();
  const agentId = store.getters.agentId;
  const callEvent = store.getters.callInfo.callEvent;

  logReport.write(`[SET_AGENT_STATE_ACTION] status: ${state}`);
  klcnsCommon.IS_CHANGE_STATUS = false;

  // 통계 서버에 상태 전달
  switch (state) {
    case '3': // 통화중 AM_INCALL
    case '8': // 링울림 AM_WORK_RINGING
      const direction = store.getters.callInfo.direction || 'I';
      store.dispatch('send_status', { agentId: agentId, data: { status: state, ioType: direction } });
      logReport.write(`[SEND-STATUS] status: ${state}, ioType: ${direction}`);
      break;
    case '4': // 통화중 (아웃바운드) AM_CALL
      store.dispatch('send_status', { agentId: agentId, data: { status: state, ioType: 'O' } });
      logReport.write(`[SEND-STATUS] status: ${state}, ioType: 'O'`);
      break;
    case '7': // 후처리 AM_WORK_NOT_READY
      store.dispatch('send_status', { agentId: agentId, data: { status: state } });
      logReport.write(`[SEND-STATUS] status: ${state}`);
      if (callEvent === klcnsEvent.ORIGINATE_ACTION || callEvent === klcnsEvent.ANSWER_ACTION) {
        logReport.write('[EVENT-PROCESS] [CHANGE-CALL-EVENT] Hangup');
        store.commit('changeCallEvent', klcnsEvent.HANG_UP);
        doHangup();
      }
      break;
    default:
      store.dispatch('send_status', { agentId: agentId, data: { status: state } });
      logReport.write(`[SEND-STATUS] status: ${state}`);
  }
}

function originateAction(response) {
  logReport.write(`[ORIGINATE-ACTION] response: ${response}`);
  if (response === 'Success') {
    store.commit('changeCallEvent', klcnsEvent.ORIGINATE_ACTION);
    const tempDrc = 'O';
    store.commit('changeDirection', tempDrc);
    klcnsSetAgentStatus(klcnsAgtStaDefs.AgentMode.AM_CALL);
  }
}

function answerAction(response) {
  const callEvent = store.getters.callInfo.callEvent;
  if (response === 'Success') {
    apiEvent.buttonState(klcnsAgtStaDefs.STATE_ESTABLISHED);
    if (callEvent !== klcnsEvent.AT_XFER) {
      store.commit('changeCallEvent', klcnsEvent.ANSWER_ACTION);
    }
    store.commit('changeStartTime', new Date().getTime());
  }
}

function hangupAction() {
  if (store.getters.getIsSpying) return; // 감청 종료의 경우, hangupAction 이벤트를 무시한다.

  const callEvent = store.getters.callInfo.callEvent;
  const callStatus = localStorage.getItem('call-agent-status');
  logReport.write(`[HANG-UP-ACTION] callEvent: ${callEvent}`);
  if (JSON.parse(callStatus).status === '통화중') {
    const agentId = store.getters.agentId;
    store.dispatch('send_status', { agentId: agentId, data: { status: '7' } }); // 웹소켓이 끊겼다가 재연결 될 경우, setAgentStateAction 이벤트를 받지 못하는 경우가 발생하여 추가.
    doHangup();
  }
}

function atxferAction() {
  store.commit('changeCallEvent', klcnsEvent.ATXFER_ACTION);
}

function cancelAtxferAction() {
  // 이관 시도중에 취소하면 들어오는 이벤트
  store.commit('changeCallEvent', klcnsEvent.CANCEL_AT_XFER_ACTION);
}

function holdAudioAction(response, data) {
  logReport.write(`[HOLD-AUDIO-ACTION] response: ${response}, option: ${data.option}}`);
  if (response === 'Success') {
    if (data.option === 'on') {
      apiEvent.buttonState(klcnsAgtStaDefs.STATE_HOLD);
    } else {
      apiEvent.buttonState(klcnsAgtStaDefs.STATE_ESTABLISHED);
    }
  }
}

function getUserEvent() {
  // 추후 필요할 경우 구현
}

function ringing(data) {
  try {
    logReport.write(`[Ringing] data: ${JSON.stringify(data)}`);
  } catch (e) {
    logReport.write(`[Ringing] object parsing error`);
  }
  window.sessionStorage.setItem('isCall', Date.now());
  eventBus.$emit('call-connection', 'originated');

  if (!helpers.isObjectNotEmpty(data)) {
    logReport.write(`[RINGING] 응답에러: ${JSON.stringify(data)}`);
    return;
  }

  const callType = data.type;
  let serviceCode = '';
  let channelUniqueKey = '';

  klcnsSetAgentStatus(klcnsAgtStaDefs.AgentMode.AM_WORK_RINGING);

  if (data.uuid) {
    store.commit('changeUuid', data.uuid);
  }

  // 인바운드일 때
  if (callType === 'in') {
    serviceCode = data.queue_name;
  }
  store.commit('changeServiceCode', serviceCode);

  channelUniqueKey = data.unique_id;
  store.commit('setChannelUniqueKey', channelUniqueKey);

  if (callType === 'transfer') {
    store.commit('setIsTransferCancel', true);
    store.commit('changeCallEvent', klcnsEvent.AT_XFER);
  }

  logReport.write(`[RINGING] serviceCode: ${serviceCode}, channelUniqueVal: ${channelUniqueKey}`);

  if (callType === 'in' || callType === 'transfer') {
    store.commit('changeRecordNo', data.record_file);
    store.commit('changeDirection', 'I');
    apiEvent.buttonState(klcnsAgtStaDefs.STATE_DELIVERED_RECV);
    store.commit('changeCallUserKey', data.cid);
    eventBus.$emit('call-bound:in', data);
  } else if (callType === 'out') {
    store.commit('changeDirection', 'O');
    apiEvent.buttonState(klcnsAgtStaDefs.STATE_DELIVERED_SEND);
    const callUserKey = store.getters.callInfo.userKey;
    store.commit('changeCallUserKey', callUserKey || 'notdefined');
    // 전화기 하드웨어가 없으므로 전화기 하드웨어를 이용한 아웃바운드 케이스 예외처리는 삭제.
    eventBus.$emit('call-bound:out', data);
  }
  logReport.write(`[RINGING] direction: ${store.getters.direction}`);
}

function bridge(data) {
  const { callInfo, customerPhoneNumber } = store.getters;
  try {
    logReport.write(`[BRIDGE] data: ${JSON.stringify(data)}`);
  } catch (e) {
    logReport.write(`[BRIDGE] object parsing error`);
  }
  logReport.write(`[BRIDGE] holdStatus: ${callInfo.isHold}`);
  logReport.write(`[BRIDGE] isCustomerPhoneNumberNaN: ${isNaN(customerPhoneNumber)}`);
  logReport.write(`[BRIDGE] callEvent: ${callInfo.callEvent}`);

  if (!callInfo.isHold) {
    apiEvent.buttonState(klcnsAgtStaDefs.STATE_ESTABLISHED);
  }

  if (!helpers.isObjectNotEmpty(data)) {
    logReport.write(`[BRIDGE] 응답에러: ${JSON.stringify(data)}`);
    return;
  }

  if (isNaN(customerPhoneNumber)) {
    store.commit('changeDnis', data.rid);
    store.commit('changeCurrentCallBrand', { dnis: data.rid });
    store.dispatch('changeCallUserKey', data.record_file.split('_')[3]);
  }

  if (data.uuid) {
    store.commit('changeUuid', data.uuid);
  }

  switch (callInfo.callEvent) {
    case klcnsEvent.ANSWER_ACTION:
      store.dispatch('changeCallUserKey', data.cid);
      store.commit('changeRecordNo', data.record_file);
      logReport.write(`[BRIDGE] callEvent: ${callInfo.callEvent}, callInfo.userKey: ${callInfo.userKey}`);
      logReport.write(`[BRIDGE] cid: ${data.cid}, record: ${data.record_file}`);
      break;
    case klcnsEvent.ORIGINATE_ACTION:
      store.dispatch('changeCallUserKey', data.cid);
      store.commit('changeBrandDnis', data.rid);
      store.commit('changeDnis', data.rid);
      store.commit('changeRecordNo', data.record_file);
      store.commit('changeStartTime', new Date().getTime());
      logReport.write(`[BRIDGE] callEvent: ${callInfo.callEvent}, callInfo.userKey: ${callInfo.userKey}`);
      logReport.write(`[BRIDGE] callInfo.dnis: ${callInfo.dnis}, record: ${data.record_file}`);
      break;
    case klcnsEvent.AT_XFER:
      store.dispatch('changeCallUserKey', data.cid);
      store.commit('changeRecordNo', data.record_file);
      logReport.write(`[BRIDGE] callEvent: ${callInfo.callEvent}, callInfo.userKey: ${callInfo.userKey}`);
      logReport.write(`[BRIDGE] cid: ${data.cid}, record: ${data.record_file}`);
  }
}

function hangUp(data) {
  const { callInfo } = store.getters;
  logReport.write(`[HANG-UP] callEvent: ${callInfo.callEvent}`);
  eventBus.$emit('call-work-not-ready');
  store.commit('changeCallEvent', null);
  if (data.type === 'transfer') {
    logReport.write('TRANSFER-HANGUP');
    const agentId = store.getters.agentId;
    store.dispatch('send_status', { agentId: agentId, data: { status: '7' } });
    store.commit('changeCallEvent', klcnsEvent.TRANSFER_HANGUP);
  }
  doHangup();
}

function transferAnswer() {
  // 이관 보내는 쪽에서 받는 이벤트
  // 이관 받는 상담사가 픽업할 경우 발생한다.
  logReport.write('TRANSFER-ANSWER');
  store.commit('changeCallEvent', klcnsEvent.TRANSFER_ANSWER);
  apiEvent.endCall();
  eventBus.$emit('call-work-not-ready');
  eventBus.$emit('hidePopup', 'showTransferPopup');
}

function doHangup() {
  const callStatus = localStorage.getItem('call-agent-status');
  if (JSON.parse(callStatus).status !== '통화중') return;

  apiEvent.buttonState(klcnsAgtStaDefs.STATE_NREADY);
  store.commit('setIsTransferCancel', false);
  store.commit('changeServiceCode', '');
  eventBus.$emit('call-connection', 'cleared');
  eventBus.$emit('call-work-not-ready');
  window.sessionStorage.clear();
}

function spyCallAction(response) {
  store.commit('changeIsSpying', response === 'Success');
  logReport.write(`[SPY-CALL-ACTION] isSpyCall: ${store.getters.getIsSpying}`);
}

function spyStop() {
  if (!store.getters.getIsSpying) return;

  const preCounselingStatus = store.getters.getWorkingStatusList.find((status) => status.code === 'PRE_COUNSELING');
  store.dispatch('patchWorkingStatus', { type: 'CALL', payload: preCounselingStatus });
  apiEvent.setAgentState('AM_LOG_IN');
  store.commit('changeCallAgentStatus', '상담준비');
  apiEvent.buttonState(klcnsAgtStaDefs.AM_LOG_IN);

  store.commit('changeIsSummaryCompleted', true);
  store.commit('changeIsCallEnd', false);
  store.commit('changeCallEvent', null);
  store.commit('changeIsSpying', false);
}

export default {
  EventProc,
  klcnsStartMonitor,
  klcnsSetAgentStatus,
  klcnsGetAgentStatus,
  klcnsOriginate,
  klcnsAnswer,
  klcnsHangUp,
  klcnsTransfer,
  klcnsTransferCancel,
  klcnsHoldAudio,
  klcnsMuteAudio,
  klcnsGetUserEvent,
  klcnsSpyCall
};



// WEBPACK FOOTER //
// ./src/util/call/klcns/klcnsAPI/klcnsAPI.js